<div class="body-main">
  <div class="body-main-top">
	<div class="py-2">
		<div class="container">
			<div class="row">
				<div class="col-md-12 py-1">
					<!--form (ngSubmit)="onSubmit(applicationForm, model.id)" #applicationForm="ngForm">
						<div *ngIf="rtnData && rtnData.success == true" class="alert alert-success">
						{{ rtnData.message }}
						</div>
						<div class="form-group"> <label for="accountName">Account Name</label>
						  <input type="text" required class="form-control" id="accountName" placeholder="Select Account Name" name="accountName" #accountName="ngModel" [(ngModel)]="model.accountName">
						  <div *ngIf="rtnData && rtnData.message.accountName" class="alert alert-danger">
								{{rtnData.message.accountName}}
						 </div>
						</div>
						<div class="form-group"> <label for="projectName">Project Name</label>
						  <input type="text" required class="form-control" id="projectName" placeholder="Enter Account Name" name="projectName" #projectName="ngModel" [(ngModel)]="model.projectName">
						  <div *ngIf="rtnData && rtnData.message.projectName" class="alert alert-danger">
								{{rtnData.message.projectName}}
						 </div>
						</div>
						<div class="form-group"> <label for="applnForm">Application Form</label>
						  <form-builder  [form]="form" (change)="onChange($event)"></form-builder>
						</div>
					</form -->
					<h3>
						Application Details
						<button type="button" class="btn btn-secondary pull-right" (click)="backtoSection('dashboard')" >Back to Dashboard</button>
						<button type="button" class="btn btn-primary pull-right" (click)="backtoSection('rule')" >Create Rule</button>
						<!-- <button type="button" class="btn btn-primary pull-right" (click)="backtoSection('ageconfig')" >Age Config</button> -->
					</h3>
					<form  (ngSubmit)="onSubmit(applicationForm)" #applicationForm="ngForm">
						<div class="form-group"> <label for="accountName">Account Name : </label>
						  <!--input type="text" required class="form-control" [(ngModel)]="model.accountName" id="accountName" placeholder="Select Account Name" name="accountName" -->
						  <span >{{AccProjectdet.accountName}}</span>
						  <!-- <span>{{account.accountName}}</span> -->
							<!-- <select name="accountName" id="accountName" [(ngModel)]="model.accountName" (change)="getProjects()" #accountName="ngModel">
								<option value="" > Select Account </option>
								<option *ngFor="let account of accountData" value="{{account._id}}" >{{account.accountName}}</option>
							</select> -->
						</div>
						<div class="form-group"> <label for="projectName">Project Name : </label>
							<span >{{AccProjectdet.projectName}}</span>
						  <!--input type="text" required class="form-control" [(ngModel)]="model.projectName" id="projectName" placeholder="Enter Account Name" name="projectName" -->
						  <!-- <select name="projectName" id="projectName" [(ngModel)]="model.projectName" (change)="getAppln()" #projectName="ngModel">
								<option value="" > Select Project </option>
								<option *ngFor="let project of projectData" value="{{project.projectid}}" >{{project.projectName}}</option>
							</select> -->
						</div>
						<div class="form-group"> <label for="projectName">Project Identifier : </label>
							<span>{{AccProjectdet.projectIdentifier}}</span>
						</div>
						<div class="form-group"> <label for="projectName">Project ID : </label>
							<span>{{AccProjectdet.projectid}}</span>
						</div>
						<!-- -->
						<div class="form-group" *ngIf="(form['components']?.length > 0 || applNew == 1 )?true:false"> <label for="applnForm"><h3>Application Form</h3></label>
						  <form-builder  [form]="form" (change)="onChange($event)" ></form-builder>
						</div>
						<div class="form-group">
							<div class="col-md-4">
								<button type="button" class="btn btn-secondary" (click)="backtoSection('dashboard')" >Back to Dashboard</button>
								<button type="button" class="btn btn-primary pull-right" (click) = "showPreview()" >Preview</button>
							</div>
							<div class="col-md-8">
								<button type="submit" class="btn btn-primary pull-right">Create</button>
							</div>
						</div>
						<!-- <button type="button" class="btn pull-left offset-md-2">Cancel</button> -->
					</form>
				</div>
		  </div>
		</div>
	</div>


	<!--h3 class="text-center text-muted">As JSON Schema</h3>
	<div class="well jsonviewer">
	  <pre id="json" #json></pre>
	</div>
	<formio [form]='{
		"components": [
			{
				"title": "Page 1",
				"label": "Page 1",
				"type": "panel",
				"key": "page1",
				"input": false,
				"components": [
					{
						"input": true,
						"key": "textField",
						"label": "Text Field",
						"type": "textfield"
					},
					{
						"input": true,
						"key": "textField2",
						"label": "Text Field",
						"type": "textfield"
					}
				]
			},
			{
				"title": "Page 2",
				"label": "Page 2",
				"type": "panel",
				"key": "page2",
				"input": false,
				"components": [
					{
						"input": true,
						"key": "number",
						"label": "Number",
						"type": "number"
					}
				]
			}
		],
		"display": "wizard"
	}' ></formio-->

	<div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':display}">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" aria-label="Close" (click)="hidePreview()"><span aria-hidden="true">&times;</span></button>
					<h4 class="modal-title">Preview</h4>
				</div>
				<div class="modal-body">
					<!--<formio [form]="form" (nextPage)="formioNextPagesubmit($event)" (submit)="myBeforeHooks($event)"></formio>-->
					<formio [form]="form" [refresh]="refreshForm" (nextPage)="formioNextPagesubmit($event)" (submit)="formioPagesubmit($event)" [options]="options" ></formio>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" (click)="hidePreview()" >Close</button>
				</div>
			</div><!-- /.modal-content -->
		</div><!-- /.modal-dialog -->
	</div><!-- /.modal !-->
	   <!--<textarea>{{form|json}}</textarea>-->
   </div>
</div>
<ngx-loading [show]="loading" ></ngx-loading>
